module.exports = __webpack_public_path__ + "img/tool-second-section_600.e03d8506.png";